exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image {\r\n    background-size: cover;\r\n}\r\n\r\n.mat-card {\r\n    margin-top: 10px;\r\n    padding: 10px 15px 15px !important;\r\n}\r\n\r\n/* .mat-card:last-child {\r\n    margin-bottom: 100px;\r\n} */\r\n\r\n.title-notif {\r\n    -webkit-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);\r\n            box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);\r\n}\r\n\r\n.mat-card-title {\r\n    margin-top: 0.5rem;\r\n}\r\n\r\n.mat-card-footer {\r\n    margin: 5px;\r\n    font-size: 10px;\r\n    margin-top: 1rem;\r\n}\r\n\r\n.notif-posttext {\r\n    border: 1px solid #d0d0d0;\r\n    border-radius: 5px;\r\n    background-color: #f5f5f5;\r\n    padding: 10px;\r\n    width: 80%;\r\n    right: -40px;\r\n    cursor: pointer;\r\n    color: #615f5f;\r\n    position: relative;\r\n}\r\n\r\n.notif-posttext:hover {\r\n    background-color: #d0d0d0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/pages/notifications/notifications.component.css
// module id = ../../../../../src/app/pages/notifications/notifications.component.css
// module chunks = main